import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function VideoIntro() {
  const navigate = useNavigate();
  const videoRef = useRef(null);

  useEffect(() => {
    // Skip video if airline already exists
    const playerAirline = localStorage.getItem('playerAirline');
    if (playerAirline) {
      navigate('/worldmap');
      return;
    }

    const video = videoRef.current;
    if (!video) return;

    const handleEnded = () => {
      navigate('/MainMenu');
    };

    video.addEventListener('ended', handleEnded);
    return () => video.removeEventListener('ended', handleEnded);
  }, [navigate]);

  const handleSkip = () => {
    navigate('/MainMenu');
  };

  return (
    <div className="fixed inset-0 bg-black overflow-hidden">
      <video
        ref={videoRef}
        src="./videos/VideoAirOps.mov"
        autoPlay
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      <button
        onClick={handleSkip}
        className="absolute top-6 right-6 px-4 py-2 bg-black/50 hover:bg-black/70 text-white text-sm font-light tracking-wide rounded-sm backdrop-blur-sm transition-all"
      >
        SKIP
      </button>
    </div>
  );
}